import {
  ADD_FAVOURITE_VALUE_STREAM,
  ADD_FAVOURITE_VALUE_STREAM_SUCCESS,
  FETCH_VALUE_STREAM,
  FETCH_VALUE_STREAM_SUCCESS,
  FETCH_ALL_VALUE_STREAM,
  FETCH_ALL_VALUE_STREAM_SUCCESS,
  FILTER_VALUE_STREAM,
  GET_ALL_VALUE_STREAM,
  GET_UNSELECTED_ALL_VALUE_STREAM,
  HANDLE_VALUE_STREAM_REQUEST_CLOSE,
  HIDE_VALUE_STREAM_LOADER,
  SHOW_VALUE_STREAM_LOADER,
  ON_ADD_VALUE_STREAM,
  ON_EDIT_VALUE_STREAM,
  SET_VALUE_STREAM,
  ON_ALL_VALUE_STREAM_SELECT,
  ON_VALUE_STREAM_CLOSE,
  ON_VALUE_STREAM_SELECT,
  ON_DELETE_VALUE_STREAM,
  ON_DELETE_VALUE_STREAM_SUCCESS,
  ON_FILTER_SELECTED_VALUE_STREAM,
  ON_FILTER_VALUE_STREAM_OPTION_SELECT,
  ON_SAVE_VALUE_STREAM,
  ON_SAVE_VALUE_STREAM_SUCCESS,
  ON_TOGGLE_VALUE_STREAM_DRAWER,
  SHOW_VALUE_STREAM_MESSAGE,
  UPDATE_SEARCH_VALUE_STREAM,
  ON_FETCH_SELECT_TEAM_DATA,
  ON_FETCH_SELECT_TEAM_DATA_SUCCESS,
  ON_VALUE_STREAM_TEAM_UPDATE,
} from 'constants/ActionTypes';

export const onValueStreamTeamUpdate = () => {
  return {
      type: ON_VALUE_STREAM_TEAM_UPDATE,
  };
};
export const onFetchSelectTeamData = () => {
  return {
      type: ON_FETCH_SELECT_TEAM_DATA,
  };
};
export const onFetchSelectTeamDataSuccess = (payload) => {
  return {
      type: ON_FETCH_SELECT_TEAM_DATA_SUCCESS,
      payload
  };
};
export const setValueStream = (payload) => {
  return {
      type: SET_VALUE_STREAM,
      payload
  };
};
export const fetchValueStream = (payload) => {
  return {
      type: FETCH_VALUE_STREAM,
      payload
  };
};
export const fetchValueStreamSuccess = (payload) => {
  return {
      type: FETCH_VALUE_STREAM_SUCCESS,
      payload
  };
};
export const fetchValueStreams = () => {
  return {
      type: FETCH_ALL_VALUE_STREAM
  };
};
export const fetchValueStreamsSuccess = (payload) => {
  return {
      type: FETCH_ALL_VALUE_STREAM_SUCCESS,
      payload
  };
};
export const showValueStreamMessage = (message) => {
  return {
      type: SHOW_VALUE_STREAM_MESSAGE,
      payload: message
  };
};
export const addFavouriteValueStream = (payload) => {
  return {
      type: ADD_FAVOURITE_VALUE_STREAM,
      payload
  };
};
export const addFavouriteValueStreamSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_VALUE_STREAM_SUCCESS,
      payload
  };
};
export const onValueStreamSelect = (payload) => {
  return {
      type: ON_VALUE_STREAM_SELECT,
      payload
  };
};
export const onAddValueStream = () => {
  return {
      type: ON_ADD_VALUE_STREAM,
  };
};
export const onEditValueStream = (payload) => {
  return {
      type: ON_EDIT_VALUE_STREAM,
      payload
  };
};
export const onValueStreamClose = () => {
  return {
      type: ON_VALUE_STREAM_CLOSE,
  };
};
export const onFilterValueStreamOptionSelect = (payload) => {
  return {
      type: ON_FILTER_VALUE_STREAM_OPTION_SELECT,
      payload
  };
};
export const onSaveValueStream = (payload) => {
  return {
      type: ON_SAVE_VALUE_STREAM,
      payload
  };
};
export const onSaveValueStreamSuccess = (data) => {
  return {
      type: ON_SAVE_VALUE_STREAM_SUCCESS,
      payload: data
  };
};
export const onDeleteValueStream = (payload) => {
  return {
      type: ON_DELETE_VALUE_STREAM,
      payload
  };
};
export const onDeleteValueStreamSuccess = (payload) => {
  return {
      type: ON_DELETE_VALUE_STREAM_SUCCESS,
      payload
  };
};
export const onFilterSelectedValueStream = () => {
  return {
      type: ON_FILTER_SELECTED_VALUE_STREAM,
      payload: ''
  };
};
export const filterValueStream = (payload) => {
  return {
      type: FILTER_VALUE_STREAM,
      payload
  };
};
export const getAllValueStream = () => {
  return {
      type: GET_ALL_VALUE_STREAM,
      payload: ''
  };
};
export const getUnselectedAllValueStream = () => {
  return {
      type: GET_UNSELECTED_ALL_VALUE_STREAM,
      payload: ''
  };
};
export const onAllValueStreamSelect = () => {
  return {
      type: ON_ALL_VALUE_STREAM_SELECT,
      payload: ''
  };
};
export const updateSearchValueStream = (payload) => {
  return {
      type: UPDATE_SEARCH_VALUE_STREAM,
      payload
  };
};
export const onToggleValueStreamDrawer = () => {
  return {
      type: ON_TOGGLE_VALUE_STREAM_DRAWER,
  };
};
export const handleValueStreamRequestClose = () => {
  return {
      type: HANDLE_VALUE_STREAM_REQUEST_CLOSE,
  };
};
export const showValueStreamLoader = () => {
  return {
      type: SHOW_VALUE_STREAM_LOADER,
  };
};
export const hideValueStreamLoader = () => {
  return {
      type: HIDE_VALUE_STREAM_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/valueStream.js